module.exports = __webpack_public_path__ + "img/icon-swipe.0066fc60.svg";